import { useTranslation } from "react-i18next";

const { Row } = require("reactstrap");
const { default: IconInput } = require("../iconInput/IconInput");

const defaultValueForType = (type) => {
    if (type === 'multiSelect' || type === 'skipDays' || type === 'breaks') return [];
    if (type === 'sendDays') return [1, 2, 3, 4, 5];
    if (type === 'checkbox') return false;
    return '';
};

const InputList = ({ fields = [], data = {}, onChange }) => {
    const { t } = useTranslation();

    console.log(fields)
    console.log(data)
    return (
        <Row>
            {fields.map(field => (
                <IconInput
                    key={field.key}
                    options={field.options}
                    label={t(field.label)}
                    iconKey={field.icon}
                    value={data[field.key] ?? defaultValueForType(field.type)}
                    type={field.type}
                    maxRange={field.maxRange}
                    rangeStep={field.rangeStep}
                    onChange={(e) => onChange(field.key, e.target.value)}
                    readOnly={field.readOnly}
                    md={field.md}
                    xl={field.xl}
                />
            ))}
        </Row>
    );
};

export default InputList
